import { useServicesContext } from "@modules/core/services/services.context"
import { PromoCodeEntity } from "@modules/promoCode/entities/promoCodeEntity"
import { type PromoCodeDraft } from "@modules/promoCode/types/promoCodeTypes"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export const usePromoCodesCreate = () => {
  const { promoCodeApi } = useServicesContext()
  const queryClient = useQueryClient()

  const { mutateAsync: createPromoCode, isPending } = useMutation({
    mutationFn: async (promoCodeDraft: PromoCodeDraft) => {
      const newPromoCode = await promoCodeApi.createPromoCode(promoCodeDraft)
      return PromoCodeEntity.fromDto(newPromoCode)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["promoCodes"] })
    },
  })

  return {
    createPromoCode,
    isPending,
  }
}

export const usePromoCodesUpdate = () => {
  const { promoCodeApi } = useServicesContext()
  const queryClient = useQueryClient()

  const { mutateAsync: updatePromoCode, isPending } = useMutation({
    mutationFn: async ({ id, promoCodeDraft }: { id: string; promoCodeDraft: PromoCodeDraft }) => {
      const updatedPromoCode = await promoCodeApi.updatePromoCode(id, promoCodeDraft)
      return PromoCodeEntity.fromDto(updatedPromoCode)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["promoCodes"] })
    },
  })

  return {
    updatePromoCode,
    isPending,
  }
}

export const usePromoCodesDelete = () => {
  const { promoCodeApi } = useServicesContext()
  const queryClient = useQueryClient()

  const { mutateAsync: deletePromoCode, isPending } = useMutation({
    mutationFn: async (id: string) => {
      return await promoCodeApi.deletePromoCode(id)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["promoCodes"] })
    },
  })

  return {
    deletePromoCode,
    isPending,
  }
}
